import React from 'react'
import './Promo.css'

const Promo = () => <div className="projects_promo" />

export default Promo
